import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { Map } from 'immutable'
import Button, { TYPES } from '../../Button/index'
import DurationPicker from '../../DurationPicker/index'
import OnboardingTitleGradient from '../OnboardingTitleGradient'
import OnboardingProgressBar from '../OnboardingProgressBar'

// eslint-disable-next-line react/prefer-stateless-function
class Duration extends React.Component {
  handleDurationChange = (duration) => {
    this.props.setDuration(duration)
  }

  render () {
    const { props, handleDurationChange } = this
    const {
      copy,
      setPage,
      progress,
      screenNumber,
    } = props

    return (
      <React.Fragment>
        <OnboardingTitleGradient
          title={copy.get('duration')}
          handleBackClick={() => setPage(false)}
          screenNumber={screenNumber}
          copy={copy}
          duration
        />
        <div className="onboarding-duration">
          <OnboardingProgressBar percentage={progress} />
          <div className="onboarding-duration__picker-container">
            <DurationPicker onChange={handleDurationChange} />
          </div>
          <div className="onboarding-duration__button-container">
            <Button
              type={TYPES.PRIMARY}
              onClick={function handleSubmit () {
                setPage(true)
              }}
              className="onboarding-duration__button"
            >
              {copy.get('done')}
            </Button>
          </div>
        </div>

      </React.Fragment>
    )
  }
}

export default compose(
  connectRedux(
    (state) => {
      const topics = state.onboarding.getIn(['v5Data', 'rank-interests'], Map())
      return {
        topics,
      }
    },
    null,
  ),
)(Duration)
